/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography, Divider } from '@mui/material';
import { Location } from 'history';
import React, { useState } from 'react';
import { CommonLayout, } from '../../commonComponents';
import { useHistory } from 'react-router';
import DocumentViewTabPanel from './document-view';

export default function documentDownload({
  location,
}: {
  location: Location<{ investorId: string; investorName: string }>;
}): JSX.Element {

  const history = useHistory();
  const [value, setValue] = useState('view'); // This is Default Tablist Value

  const handleTablistChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };


  return (
    <>
      <CommonLayout>
        <Box sx={{ padding: { xs: 2, sm: 1 } }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 18,
              fontWeight: 500,
              // mb: { xs: 2, md: 4 },
              p: { xs: '5px 15px', md: '' },
              bgcolor: '#e5f1f8',
              borderRadius: '10px',
            }}>
            Documents
            {/* (As of {new Date(dates1).toLocaleDateString('en-GB')}) */}
          </Typography>
          <Box
            sx={{
              width: '100%',
              '& .MuiTabPanel-root': { py: 2, px: 0 },
              '& .MuiTab-root': {
                color: '#A1A2A2',
                opacity: 0.8,
                fontSize: 17,
                lineHeight: '24px',
                textTransform: 'capitalize',
                px: { xs: 2, md: 3, lg: 5 },
                '&.Mui-selected': {
                  color: '#4B81B1',
                },
              },
              '& .MuiTabs-indicator': {
                height: 2,
                background: '#4B81B1',
              },
            }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={handleTablistChange}
                  aria-label="Documents tabs"
                  variant="scrollable"
                  scrollButtons="auto">
                  <Tab label="View" value="view" />
                  {/* <Tab label="Edit" value="edit" /> */}
                </TabList>
                <Divider />
              </Box>

              {/*  This is View Tab Pannel */}
              <TabPanel value="view">
                <DocumentViewTabPanel />
              </TabPanel>

            </TabContext>
          </Box>
        </Box>
      </CommonLayout >
    </>
  );
}
